import React from 'react';

const PageSpinner = ({ className, rendered, hidden }) => (
  rendered &&
  <div className={`bg-gray-2 a-webreader-spinner absolute-centering ${className} ${hidden?'hidden':''}`}>
    <div className="a-webreader-spinner-bg fit fit-height"></div>
    <img className="absolute-centering" src="/images/webreader/page-spinner.svg" alt=""/>
  </div>
);

PageSpinner.defaultProps = {
  className: '',
  rendered: true,
  hidden: false
};

export default PageSpinner;